<template lang="pug">
.container
  el-header
    span(v-if="editedDeviceId && !isLoading") {{$t('Device')}}&nbsp;
      span {{ newEditedDevice.name }}
      span(v-if='!isLoading && newEditedDevice.DeviceDesktops.length === 1')
        | &nbsp; &nbsp;
        font-awesome-icon(icon="map-marked-alt")
        | &nbsp; &nbsp;
        span(v-if='getGroupFromDesktop(newEditedDevice.DeviceDesktops[0])') {{ getGroupFromDesktop(newEditedDevice.DeviceDesktops[0]).name }}
        span.warning(v-else) {{ $t('Device has no location assigned') }}
      span.muted(v-if='!isLoading && newEditedDevice.DeviceDesktops.length > 1') {{ $t('Please refer to Monitors Tab for locations') }}
    span(v-if="!editedDeviceId && !isLoading") {{$t('Add device ')}}
    hr.header
  el-row(v-if='isLoading')
    el-col(:span="24")
      h4
        i.el-icon-loading
        span &nbsp; {{ $t('Loading device...')}}
  el-row(v-if='!isLoading')
    el-col(:span="24")
      el-form.search-form-inline(:inline='true', size="mini")
        el-form-item(v-if='!newEditedDevice.id', :label='$t("Template")')
          el-select(id="AddEditDevice-templateSelect" v-model='templateId', :placeholder='$t("Select")', clearable)
            el-option(v-for='template in templates', :key='template.id', :label='template.name', :value='template.id', :id="'AddEditDevice-templateOption'+template.id")
        el-form-item.label(:label='$t("Name")')
          el-input(id="AddEditDevice-nameInput" v-model='newEditedDevice.name', :placeholder='$t("Name (at least 3 characters)")')
        el-form-item.label(:label='$t("Description")')
          el-input(id="AddEditDevice-descriptionInput" v-model='newEditedDevice.description', :placeholder='$t("Description")')
        el-form-item.label(v-if='newEditedDevice.id', :label='$t("Deployed")')
          el-checkbox(id="AddEditDevice-deployedCheckbox" v-model="newEditedDevice.active", @change="updateDeviceActivationTs")
        el-form-item.label(v-if='newEditedDevice.id && inTestNetwork', :label='$t("Test")', :disabled='this.$store.state.User.test')
          el-checkbox(id="AddEditDevice-testCheckbox" v-model="newEditedDevice.test")
        el-form-item
          el-button.save-device(id="AddEditDevice-saveButton" type='success', @click='createUpdateDevice()', :disabled='!__canSaveDevice() || savingDevice || (!newEditedDevice.test && $store.state.User.user.test)')
            span {{ savingDevice ? $t('saving...'): getSaveDeviceText() }}
        el-form-item(v-if='this.$store.state.User.user.userPrivileges.filter(up => up.entity === "device" && up.method === "DELETE")')
          el-button.save-device(id="AddEditDevice-saveButton" type='success', @click='destroyDevice()', :disabled='!__canDestroyDevice() || deletingDevice || (!newEditedDevice.test && $store.state.User.user.test)')
            span {{ deletingDevice ? $t('deleting...'): $t('Delete') }}
        el-form-item(v-if='newEditedDevice.id')
          el-button.float-right(id="AddEditDevice-saveAsTemplateButton" type='success', @click='createDeviceTemplateVisible = true', :disabled='$store.state.User.user.test')
            span {{ $t('Save Device as Template')}}
  el-row
    hr.header
  el-row(v-if='newEditedDevice && newEditedDevice.id')
    el-col(:span="24")
      el-tabs(type='border-card', v-model='activeTabName')
        el-tab-pane(id="AddEditDevice-heartbeatPane" name='heartbeat')
          span(slot='label')
            font-awesome-icon(icon="heartbeat")
            span &nbsp; {{$t('Heartbeat Data')}}
          .hbdata(v-if='key !== "extra"', v-for="(hbdata, key) of getHBData(newEditedDevice.DeviceDesktops[0])", :key='key')
            span.hbdata-label.selectable {{ $t(key) }}
            span.hbdata-data.selectable
              span(v-if='key !== "Timestamp" && key !== "uptime"') {{ hbdata ? hbdata : '-' }}
              span(v-if='key === "Timestamp"') {{ hbdata != '0' ? humanTime(parseInt(hbdata)) : '-' }}
              span(v-if='key === "uptime"') {{ hbdata != '0' ? humanDuration(parseInt(hbdata) * 1000) : '-' }}
          .hbdata.selectable(v-for="(extradata, extrakey) of basicExtraHBData", :key='extrakey')
            span.hbdata-label {{ $t(extrakey) }}
            span.hbdata-data
              span(v-if='extrakey === "appUptime"') {{ extradata != '0' ? humanDuration(parseInt(extradata) * 1000) : '-' }}
              span(v-else-if='extrakey === "freeSDCard"') {{ extradata != '0' ? humanFileSize(parseInt(extradata)) : '-' }}
              span(v-else) {{ extradata }}
          .alerts-container(v-if='alertsExtraHBData.length > 0')
            Alerts(:alerts="alertsExtraHBData")
          .downtimes(v-if='newEditedDevice.active')
            Downtimes(:deviceId="newEditedDevice.id")
          .downtimes(v-if='!newEditedDevice.active')
            p {{$t('Device not deployed. Disconnection episodes are registered only for deployed devices.')}}
        el-tab-pane(id="AddEditDevice-requestsPane" name='requests')
          span(slot='label')
            font-awesome-icon(icon="wrench")
            span &nbsp; {{$t('Requests')}}
          DeviceRequests(:device="newEditedDevice")
        //- COMMANDS ARE UNSUSED. YET...?
        //- el-tab-pane
        //-   span(slot='label')
        //-     font-awesome-icon(icon="terminal")
        //-     span &nbsp; {{$t('Commands')}}
        //-   EditCommands(:newEditedDevice="newEditedDevice")
        el-tab-pane(id="AddEditDevice-configPane" name='config')
          span(slot='label')
            font-awesome-icon(icon="cogs")
            span &nbsp; {{$t('Config Metadata')}}
          .warning(v-if='saveConfigMessage.length > 0') {{ saveConfigMessage }}
          el-form
            el-form-item(:label="$t('JSON')")
              el-input(id="AddEditDevice-configInput" :placeholder="$t('{}')", v-model='newEditedDevice.configMetadata', type="textarea", @input='configParseError = false', :rows='7', :cols='40')
            el-button-group.float-right
              el-button(id="AddEditDevice-saveConfigButton" type='success', size="small", :disabled="savingConfig", @click='saveDeviceConfigMetadata()')
                span(v-if='!savingConfig') &nbsp; {{ $t('Save and send config metadata') }}
                span(v-else) &nbsp; {{ $t('sending...') }}
                span &nbsp; &nbsp;
                font-awesome-icon(icon="save")
                span &nbsp; &nbsp;
                font-awesome-icon(icon="upload")
        el-tab-pane(id="AddEditDevice-schedulePane" name='schedule')
          span(slot='label')
            font-awesome-icon(icon="calendar-alt")
            span &nbsp; {{$t('Schedule')}}
          EditSchedule(id="AddEditDevice-editSchedule" :newEditedDevice="newEditedDevice", @reloadDevice='reload')
          .error(v-if='configParseError') {{ $t('Unable to parse JSON...')}}
        el-tab-pane(id="AddEditDevice-propertiesPane" name='properties')
          span(slot='label')
            font-awesome-icon(icon="info")
            span &nbsp; {{$t('Properties')}}
          EditProperties(id="AddEditDevice-editProperties" :newEditedDevice="newEditedDevice", @reloadDevice='reload')
        el-tab-pane(id="AddEditDevice-desktopsPane" name='desktops')
          span(slot='label')
            font-awesome-icon(icon="desktop")
            span &nbsp; {{$t('Monitors')}}
          EditMonitorsDesktops(id="AddEditDevice-editDesktops" :newEditedDevice="newEditedDevice", @reloadDevice = 'reload')
        el-tab-pane(id="AddEditDevice-tagsPane" name='tags')
          span(slot='label')
            font-awesome-icon(icon="tags")
            span &nbsp; {{$t('Tags')}}
          .switch-tag-editor-type
            el-button(id="AddEditDevice-tagsViewButton" type='text', size='mini', @click='switchTagViewMode()')
              font-awesome-icon(:icon="!deviceTagDropdownViewActive ? 'list' : 'tags'")
          TagsEditorSimple(
            v-if='newEditedDevice && newEditedDevice.id && !deviceTagDropdownViewActive',
            id="AddEditDevice-tagsEditorSimple",
            :newEditedDevice="newEditedDevice",
            @reloadDevice='reload',
          )
          TagsEditorDropdown(
            v-if='newEditedDevice && newEditedDevice.id && deviceTagDropdownViewActive',
            id="AddEditDevice-tagsEditorDropdown",
            :newEditedDevice="newEditedDevice",
            @reloadDevice='reload',
          )
        el-tab-pane(id="AddEditDevice-chaosPane" name='Chaos', v-if='isAdminOrSuperAdmin')
          span(slot='label')
            font-awesome-icon(icon="cogs")
            span &nbsp; {{$t('Chaos data')}}
          ChaosInfo(id="AddEditDevice-ChaosInfo" :newEditedDevice="newEditedDevice", @reloadDevice='reload')
  el-dialog(:close-on-click-modal="false", title='', :visible.sync='createDeviceTemplateVisible', @close='closeCreateDeviceTemplate()', @closeCreateDeviceTemlate='closeCreateDeviceTemplate()',  append-to-body)
    CreateDeviceTemplate(id="AddEditDevice-createDeviceTemplate" v-if="newEditedDevice", :device="newEditedDevice")
</template>

<script>
import Vue from 'vue'
import EditMonitorsDesktops from './EditMonitorsDesktops'
import EditCommands from './EditCommands'
import EditProperties from './EditProperties'
import ChaosInfo from './ChaosInfo'
import TagsEditorSimple from './DeviceTagsEditorSimple'
import TagsEditorDropdown from './DeviceTagsEditorDropdown'
import EditSchedule from './EditSchedule'
import CreateDeviceTemplate from './CreateDeviceTemplate'
import DeviceRequests from './DeviceRequests'
import Downtimes from './Downtimes'
import Alerts from './Alerts'

import textUtils from '../Common/textUtils.mixin'
import deviceUtils from '../Common/deviceUtils.mixin'
import userUtils from '../Common/userUtils.mixin'

export default {
  mixins: [textUtils, deviceUtils, userUtils],
  components: {
    EditMonitorsDesktops,
    EditCommands,
    EditProperties,
    TagsEditorSimple,
    TagsEditorDropdown,
    EditSchedule,
    CreateDeviceTemplate,
    DeviceRequests,
    Downtimes,
    Alerts,
    ChaosInfo
  },
  props: ['side', 'editedDeviceId'],
  async created () {
    this.deviceTagDropdownViewActive = this.$store.state.User.user.deviceTagDropdownViewActive
    await this.load()
    await this.__getDeviceTemplates()
  },
  async updated () {
  },
  data () {
    return {
      errors: [],
      newEditedDevice: {
        active: false,
        canConcatMonitors: true,
        reportErrors: true,
        id: undefined
      },
      createDeviceTemplateVisible: false,
      templates: undefined,
      value: '',
      templateId: undefined,
      configParseError: false,
      savingConfig: false,
      deletingDevice: false,
      saveConfigMessage: '',
      savingDevice: false,
      isLoading: false,
      activeTabName: 'heartbeat',
      deviceTagDropdownViewActive: false
    }
  },
  methods: {
    async switchTagViewMode () {
      this.deviceTagDropdownViewActive = !this.deviceTagDropdownViewActive
      await this.setViewPreference()
    },
    async setViewPreference () {
      await Vue.axios.post('user/setViewPreference', {
        deviceTagDropdownViewActive: this.deviceTagDropdownViewActive
      })
      await this.$store.dispatch('User/getMe')
    },
    setActiveTab (tab) {
      this.activeTabName = tab
    },
    async updateDeviceActivationTs (val) {
      this.newEditedDevice.activationTs = val ? new Date().getTime() : null
    },
    getHBData (desktop) {
      const hbData = {}
      for (const key in desktop) {
        if (key.startsWith('HB') || key === 'extraHB') {
          hbData[key.replace('HB', '')] = desktop[key]
        }
      }
      hbData['freeMem'] = hbData['freeMem'] > 1 ? this.humanFileSize(hbData['freeMem']) : false
      hbData['freeDisk'] = hbData['freeDisk'] > 1 ? this.humanFileSize(hbData['freeDisk']) : false
      return hbData
    },
    async load () {
      if (this.editedDeviceId) {
        this.isLoading = true
        this.newEditedDevice = (await Vue.axios.get(`device/${this.editedDeviceId}`)).data
        this.newEditedDevice.configMetadata === null ? this.newEditedDevice.configMetadata = '' : this.newEditedDevice.configMetadata = JSON.stringify(this.newEditedDevice.configMetadata, undefined, 4)
        this.isLoading = false
      }
    },
    async reload () {
      this.newEditedDevice = []
      await this.load()
    },
    closeCreateDeviceTemplate () {
      this.createDeviceTemplateVisible = false
    },
    async __getDeviceTemplates () {
      await Vue.axios
        .get('devicetemplate')
        .then(response => {
          this.templates = response.data
        })
    },
    async createUpdateDevice () {
      this.savingDevice = true
      if (this.templateId) {
        await this.createDeviceFromTemplate()
        return
      }
      if (!this.newEditedDevice.id) {
        await this.__createDevice()
      } else {
        await this.__updateDevice()
      }
      this.savingDevice = false
    },
    async destroyDevice () {
      this.deletingDevice = true
      await this.$store.dispatch('Device/destroy', this.newEditedDevice.id)
      window.location.reload()
    },
    getSaveDeviceText () {
      if (this.templateId && !this.newEditedDevice.id) {
        return this.$t('Create device')
      }
      if (!this.newEditedDevice.id) {
        return this.$t('Create device')
      } else {
        return this.$t('Update device')
      }
    },

    __canSaveDevice () {
      return this.newEditedDevice.name && this.newEditedDevice.name.length > 3
    },
    __canDestroyDevice () {
      if (
        // device is in deleted (trash) network
        this.currentUserNetwork.deleted ||
        // or device has never been deployed and activated (it is blue in Wave)
        (!this.newEditedDevice.active && this.newEditedDevice.DeviceDesktops.filter(dd => dd.alive && dd.HBTimestamp > 0).length === 0)
      ) {
        return true
      }
      return false
    },
    async __createDevice () {
      this.errors = []
      if (!this.__canSaveDevice()) return this.errors.push('please provide valid device name > 3 chars')
      await Vue.axios.post('device', this.newEditedDevice)
      await this.$store.dispatch('Device/getDeviceList')
    },
    async createDeviceFromTemplate () {
      this.errors = []
      if (!this.newEditedDevice.name || this.newEditedDevice.name.length < 4) return this.errors.push('please provide valid device name > 3 chars')
      await Vue.axios
        .post('deviceTemplate/createDeviceFromDeviceTemplate', {
          name: this.newEditedDevice.name,
          description: this.newEditedDevice.description,
          deviceTemplate: this.templateId
        })
        .then(response => {
          if (response.data.id) this.newEditedDevice = response.data
          this.newEditedDevice.configMetadata === null ? this.newEditedDevice.configMetadata = '' : this.newEditedDevice.configMetadata = JSON.stringify(this.newEditedDevice.configMetadata, undefined, 4)
          this.templateId = undefined
        })
      await this.$store.dispatch('Device/getDeviceList')
    },
    async saveDeviceConfigMetadata () {
      this.configParseError = false
      this.savingConfig = true
      this.saveConfigMessage = ''
      try {
        JSON.parse(this.newEditedDevice.configMetadata)
      } catch (e) {
        this.savingConfig = false
        this.configParseError = true
        return false
      }
      await Vue.axios
        .post('device/updateConfig', { deviceId: this.newEditedDevice.id, configMetadata: JSON.parse(this.newEditedDevice.configMetadata) }, { disableResponseInterceptors: true })
        .catch(error => {
          if (error.response.status === 400 && error.response.data.errorType === 'NO_UUID_IN_DEVICE') {
            this.saveConfigMessage = this.$t('Config was saved. However it was not sent to Device, beacuse it has no UUID defined. Please refer to Monitors tab.')
          } else {
            this.$store.dispatch('Error/setAxiosError', error.response)
          }
        })
      this.savingConfig = false
    },
    async __updateDevice () {
      let device = JSON.parse(JSON.stringify(this.newEditedDevice))
      delete device.configMetadata
      for (const property in device) {
        if (device.hasOwnProperty(property)) {
          if (typeof device[property] === 'object') delete device[property]
        }
      }
      this.$store.dispatch(
        'Device/updateCollection',
        (await Vue.axios.patch('device/' + this.newEditedDevice.id, device)).data
      )
    }
  },
  computed: {
    basicExtraHBData () {
      try {
        const basicExtraHBData = JSON.parse(this.getHBData(this.newEditedDevice.DeviceDesktops[0]).extra)
        delete basicExtraHBData.alerts
        return basicExtraHBData
      } catch (e) {
        return []
      }
    },
    alertsExtraHBData () {
      try {
        const alertsExtraHBData = JSON.parse(this.getHBData(this.newEditedDevice.DeviceDesktops[0]).extra)
        if (alertsExtraHBData.alerts) {
          return alertsExtraHBData.alerts
        } else {
          return []
        }
      } catch (e) {
        return []
      }
    },
    inTestNetwork () {
      return this.$store.state.User.user.Networks.find(n => n.id === this.$store.state.User.user.lastNetworkId).test
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.container {
  font-size: $--font-size-base;
}
.error {
  color: $--color-warning;
}
.save-device {
  background-color: $--color-success !important;
  color: $--color-text-primary !important;
}
.hbdata {
  display: flex;
  font-size: $--font-size-base;
  height: 30px;
  border-bottom: $--border-light;
  align-items: center;
  .hbdata-label {
    width: 200px;
    color: $--color-text-secondary;
  }
}
.switch-tag-editor-type {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Device/AddEditDevice.vue